import { Toaster as Sonner, toast } from 'sonner';
import { CheckCircleIcon, InfoIcon, WarningIcon, XCircleIcon } from '@phosphor-icons/react';
import { useTheme } from '@/app/theme';

/**
 * Toaster in the brand style. Call `toast.success('Αποθηκεύτηκε')`, `toast.error(...)`, `toast.promise(...)`
 * from anywhere (re-exported from '@/ui').
 */
export function Toaster() {
  let theme: 'light' | 'dark' = 'light';
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    theme = useTheme().resolved;
  } catch {
    /* outside ThemeProvider (tests) */
  }
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      gap={10}
      offset={20}
      visibleToasts={4}
      icons={{
        success: <CheckCircleIcon weight="fill" className="size-5 text-success" />,
        error: <XCircleIcon weight="fill" className="size-5 text-negative" />,
        warning: <WarningIcon weight="fill" className="size-5 text-warning" />,
        info: <InfoIcon weight="fill" className="size-5 text-info" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'group flex w-[min(24rem,calc(100vw-2.5rem))] items-start gap-3 rounded-md border border-hairline bg-surface-raised px-4 py-3.5 text-ink shadow-lg font-sans',
          title: 'text-[0.875rem] font-semibold leading-5',
          description: 'mt-0.5 text-sm text-ink-muted',
          icon: 'mt-px shrink-0',
          actionButton:
            'ml-auto shrink-0 self-center rounded-sm bg-ink px-2.5 py-1 text-xs font-semibold text-ink-inverse hover:opacity-90',
          cancelButton:
            'ml-auto shrink-0 self-center rounded-sm px-2 py-1 text-xs text-ink-muted hover:bg-sunken',
          closeButton: 'text-ink-subtle',
        },
      }}
    />
  );
}

export { toast };
